$(document).ready(function () {
  
  $(".lookbook-lists").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });

  $(".services_slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });


   $('.main-images-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumb-images-slider'
  });
  $('.thumb-images-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-images-slider',
    arrows: false,
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });
  
  
});

// header nav link clicks
document.querySelectorAll('.utility-bar__inner .header_utility_link')
.forEach(link => {
  link.addEventListener('click', function (e) {
    const label = this.getAttribute('aria-label');

    if (label === 'Search') {
      setTimeout(() => {
        const search = document.querySelector('.header__icon-link[aria-label="Search"]');

        if (search) {
          search.click();
        }
      }, 0);

    } else if (label === 'Bag') {
      setTimeout(() => {
        const cart = document.querySelector('.header__icon-link[aria-label="Cart"]');
        if (cart) {
          cart.click();
        }
      }, 0);
    }
  });
});

// footer menu set to accordian 
if (window.matchMedia('(max-width: 768px)').matches) {
  document.querySelectorAll('.townhouse-footer__link-column').forEach(column => {
    const heading = column.querySelector('.townhouse-footer__column-heading');
    const menu = column.querySelector('.townhouse-footer__menu');

    if (!heading || !menu) return;

    heading.addEventListener('click', function () {
      // Remove active/open from all other columns
      document.querySelectorAll('.townhouse-footer__link-column').forEach(otherColumn => {
        if (otherColumn !== column) {
          otherColumn
            .querySelector('.townhouse-footer__column-heading')
            ?.classList.remove('active');

          otherColumn
            .querySelector('.townhouse-footer__menu')
            ?.classList.remove('accordian_open');
        }
      });

      // Toggle current column
      this.classList.toggle('active');
      menu.classList.toggle('accordian_open');
    });
  });
}


